import { Modal } from '@oy/uidesktop';
import { DevConfigForm } from '../DevConfigForm';

type DevConfigModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DevConfigModal = ({ isOpen, onClose }: DevConfigModalProps) => {
  return (
    <Modal
      onClose={onClose}
      show={isOpen}
      id="mdlDevConfig"
      closeOnBackdropClick
    >
      <Modal.Header showCloseButton>Dev Config</Modal.Header>
      <Modal.Body>
        <DevConfigForm />
      </Modal.Body>
    </Modal>
  );
};

export default DevConfigModal;
